import React, { useEffect, useMemo, useState } from "react";
import { CssBaseline, ThemeProvider } from "@material-ui/core";

import { createAppTheme } from "./theme/theme";
import IndexScreen from "./screens";
import { getDirection, lang } from "./localization";

import "./App.css";

const THEME_STORAGE_KEY = "mehdi-site-theme";

function getInitialThemeMode() {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    return stored === "light" ? "light" : "dark";
  } catch (error) {
    return "dark";
  }
}

export default function App() {
  const direction = getDirection();
  const [themeMode, setThemeMode] = useState(getInitialThemeMode);
  const theme = useMemo(() => createAppTheme(themeMode), [themeMode]);

  useEffect(() => {
    document.documentElement.setAttribute("dir", direction);
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("data-theme", themeMode);
    document.body.setAttribute("dir", direction);
    document.body.setAttribute("data-language", lang);
    document.body.setAttribute("data-theme", themeMode);

    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute("content", themeMode === "dark" ? "#060D18" : "#F3F7FC");
    }
  }, [direction, themeMode]);

  const handleThemeChange = (nextMode) => {
    const safeMode = nextMode === "light" ? "light" : "dark";
    setThemeMode(safeMode);

    try {
      localStorage.setItem(THEME_STORAGE_KEY, safeMode);
    } catch (error) {
      // The site still works when storage is unavailable.
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className={`app-root app-root--${direction}`}>
        <IndexScreen themeMode={themeMode} onThemeChange={handleThemeChange} />
      </div>
    </ThemeProvider>
  );
}
